
import { Base } from '../base-component';

import { AnalyticsService } from '../../services/analytics.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import './form-item-cmb-eligibility-need-help.component.scss';

import * as $ from 'jquery';

export class FormItemCmbEligibilityNeedHelp extends Base {

	// form
	form: HTMLFormElement;
	callmebackFormId: any;

	// buttons
	buttonSubmit: Element[];

	// select
	selectTitle: any;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.selectTitle = this.element.querySelector('.js-title');
		this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
	}

	bindEvents() {

		this.selectTitle.addEventListener('change', (event)=>{
			let element = event.target;
			this.addMoreTitle(element);
		});

		this.buttonSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select, textarea');
			const validation = this.validationService.validate(formFields);
			if (validation.valid) {

				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));

			}
		}));

		$(document).on('click', '.js-apply-now-modal-open', (event) => {
			let element = event.target;
			let modal = $(element).attr('data-modal');
			if(modal){
				this.callmebackFormId = modal;
			}
		});

	}

	addMoreTitle(element) {
		if(element){
			if(element.value == 'Other'){

				let parentParent = element.closest('.form__fields--container');
				let parent = element.closest('.form__group');

				let newContainer = document.createElement('div');
				newContainer.classList.add('form__group');
				newContainer.classList.add('js-other-title-container');

				let newLabel = document.createElement('label');
				newLabel.classList.add('form__label');
				newLabel.innerHTML = 'Other Title';
				newContainer.appendChild(newLabel);

				let newInput = document.createElement('input');
				newInput.classList.add('js-other-title');
				newInput.classList.add('form__input');
				newInput.classList.add('form__input--required');
				newInput.setAttribute('placeholder', 'Enter your title');
				newInput.setAttribute('maxlength', '4');
				newInput.setAttribute('name', 'other-title');
				newContainer.appendChild(newInput);

				parentParent.insertBefore(newContainer, parent.nextSibling);

			}else{
				let parentParent = element.closest('.form__fields--container');
				let oldInput = this.element.querySelector('.js-other-title-container');
				if(oldInput){
					parentParent.removeChild(oldInput);
				}
			}
		}
	}	

	resetForm() {
		if (this.form) {
			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const title: any = this.form.querySelector('select[name=title]');
		const titleOther: any = form.querySelector('input[name=other-title]');
		const firstName: any = form.querySelector('input[name=first-name]');
		const surname: any = form.querySelector('input[name=surname');
		const dailingCode: any = form.querySelector('select[name=dailing-code');
		const telephone: any = form.querySelector('input[name=telephone');
		const email: any = form.querySelector('input[name=email');
		const comments: any = form.querySelector('textarea[name=comments');
		const pageUrl: any = window.location.href;

		let postData = '';
		if (title) {
			if(titleOther){
				postData += 'title=' + titleOther.value + '&';
			}else{
				postData += 'title=' + title.value + '&';
			}
		}
		if (firstName) {
			postData += 'firstName=' + firstName.value + '&';
		}
		if (surname) {
			postData += 'surname=' + surname.value + '&';
		}
		if (dailingCode) {
			postData += 'dialCode=' + dailingCode.value + '&';
		}
		if (telephone) {
			postData += 'tel=' + telephone.value + '&';
		}
		if (email) {
			postData += 'email=' + email.value + '&';
		}
		if (comments) {
			postData += 'comments=' + comments.value + '&';
		}
		if (this.callmebackFormId) {
			postData += 'callmebackFormId=' + this.callmebackFormId + '&';
		}
		if (pageUrl) {
			postData += 'pageUrl=' + pageUrl + '&';
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/Feedback.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {
			// service ok
			loader.classList.remove('active');
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');

		}).catch(function (response) {
			// service failed
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');

		});

	}

}



// WEBPACK FOOTER //
// ./components/form-item-cmb-eligibility-need-help/form-item-cmb-eligibility-need-help.component.ts